import type { HTMLAttributes, Ref } from 'react';

import { badgeVariants, type BadgeVariantProps } from './badge-variants';

import { cn } from '@/lib/cn';

export type BadgeProps = HTMLAttributes<HTMLDivElement> &
  BadgeVariantProps & { ref?: Ref<HTMLDivElement> };

export const Badge = ({ className, variant, ref, ...props }: BadgeProps) => (
  <div ref={ref} className={cn(badgeVariants({ variant }), className)} {...props} />
);
Badge.displayName = 'Badge';
